<ng-container *ngIf="benefitInstallments$ | async as installments">
  <div class="installments__divider">
    <app-ds-divider></app-ds-divider>
  </div>
  <div class="installments" [class.view-car]="isAutoCarView">
    <div class="installments__cont" [ngClass]="{'installments__cont--cms': isCMS}">
      <div class="installments__price" [ngClass]="{'installments__price--cms': isCMS}">
        <span>
          {{ 'INSTALLMENTS_INFO.LABEL' | transloco : { installments: installments.installments_max_amount, product: productText, price: installmentValue$ | async | currencyFormat: currencyCode } }}
          {{installments.installments_additional_text}}
        </span>
      </div>
      <div *ngIf="showPartners" class="installments__partner-banks" (click)="viewPartners(installments.installments_max_amount, $event)">
        <ng-container *ngIf="!isDesktop; else textTemplate">
          <i aria-hidden="true" class="icon-info"></i>
          <span>
            {{ partnerTitle | transloco}}
          </span>
        </ng-container>
      </div>
    </div>
  </div>
  <ng-template #textTemplate>
    <span>
      <i aria-hidden="true" class="icon-info"></i>
      {{ partnerTitle | transloco }}
    </span>
  </ng-template>
</ng-container>
